import { InfoTooltipIcon } from "./InfoTooltipIcon"

export const RatingPeriodInfoTooltipIcon = () => {
  return <InfoTooltipIcon label="Hvilken tidsperiode målingen gjennomføres for" />
}
